export const LIVE_API_BASE_URL =
  "https://w8909dj2r4.execute-api.us-east-1.amazonaws.com/development";

export const LOCAL_API_BASE_URL = "http://localhost:9000";

const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const proxyTarget = (
  process.env.REACT_APP_API_PROXY_TARGET?.trim() || LOCAL_API_BASE_URL
).replace(/\/$/, "");

const isDevelopment = process.env.NODE_ENV === "development";
const isProduction = process.env.NODE_ENV === "production";
const forceLiveApi = process.env.REACT_APP_FORCE_LIVE_API === "true";

const isLocalhostUrl = (url = "") =>
  url.includes("localhost") || url.includes("127.0.0.1");

const isBrowserLocalHost = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  );
};

const shouldUseDevProxy = () =>
  isDevelopment &&
  process.env.REACT_APP_USE_DEV_PROXY !== "false" &&
  isBrowserLocalHost();

const resolveApiBaseUrl = () => {
  // Local `npm start` on localhost:3000 — never call live AWS unless forced.
  if (isDevelopment && isBrowserLocalHost() && !forceLiveApi) {
    if (shouldUseDevProxy()) {
      return "";
    }

    if (configuredBaseUrl && isLocalhostUrl(configuredBaseUrl)) {
      return configuredBaseUrl.replace(/\/$/, "");
    }

    return LOCAL_API_BASE_URL;
  }

  if (shouldUseDevProxy()) {
    return "";
  }

  if (configuredBaseUrl) {
    return configuredBaseUrl.replace(/\/$/, "");
  }

  if (isDevelopment) {
    return LOCAL_API_BASE_URL;
  }

  if (isProduction) {
    return LIVE_API_BASE_URL;
  }

  return LIVE_API_BASE_URL;
};

const API_BASE_URL = resolveApiBaseUrl();

export const API_PROXY_TARGET = proxyTarget;
export const API_HEALTH_URL = `${API_BASE_URL || proxyTarget}/version`;
export const IS_LOCAL_API =
  !API_BASE_URL ||
  isLocalhostUrl(API_BASE_URL) ||
  (isDevelopment && isBrowserLocalHost() && !forceLiveApi);

if (isDevelopment && typeof window !== "undefined") {
  const target = API_BASE_URL || `${window.location.origin} → ${proxyTarget} (proxy)`;
  console.info(`[API] Requests use: ${target}`);
}

export default API_BASE_URL;
